import { render, staticRenderFns } from "./DocSearch.vue?vue&type=template&id=1c3ce80b&scoped=true"
import script from "./DocSearch.vue?vue&type=script&lang=js"
export * from "./DocSearch.vue?vue&type=script&lang=js"
import style0 from "./DocSearch.vue?vue&type=style&index=0&id=1c3ce80b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c3ce80b",
  null
  
)

export default component.exports